import { observable, action } from "mobx";

export default class LeaderboardStore {

  @observable participant =  {};
  @observable mainBoards = [];
  @observable extraBoards =  [];
  @observable scores = [];
  @observable translations = {};
  @observable enableAutoOptin = false;
  @observable isLoading = true;
  @observable leagueDetails = {
    sportId: '',
    leagueId: ''
  };

  @action setMainBoards(boards) {
    this.mainBoards = boards;
  }

  @action setExtraBoards(boards) {
    this.extraBoards = boards;
  }

  @action setParticipant(participant) {
    this.participant = participant;
  }

  @action setIsLoading(isLoading) {
    this.isLoading = isLoading;
  }

  @action setScores(scores) {
    this.scores = scores;
  }

  @action setTranslations(translations) {
    this.translations = translations.reduce((rs, obj) => {
      rs[obj.locale_code] = obj;
      return rs;
    }, {});
  }

  @action setEnableAutoOptin(payload) {
    this.enableAutoOptin = payload;
  }

  @action setLeagueDetails(payload) {
    this.leagueDetails = payload;
  }
}


// WEBPACK FOOTER //
// ./src/app/stores/LeaderboardStore.js